module.exports = __webpack_public_path__ + "img/icon_logo.e44db6be.png";